import React from "react";
import { types } from "react-bricks/frontend";

export interface ListItemProps {
  text: string;
}

const ListItem: types.Brick<ListItemProps> = ({ text }) => {
  return <>{text}</>;
};

ListItem.schema = {
  name: "list-item",
  label: "List Item",
  category: "custom",
  hideFromAddMenu: true,
  getDefaultProps: () => ({
    text: "Example item",
  }),
  sideEditProps: [
    {
      name: "text",
      label: "Item text",
      type: types.SideEditPropType.Text,
    },
  ],
};

export default ListItem;
